import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Blog', path: '/blog' },
    { name: 'Destinations', path: '/destinations' },
    { name: 'Tips & Guides', path: '/tips-guides' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 group">
            <img 
              src="https://public.readdy.ai/ai/img_res/b5ab5398-94e8-4346-92ad-4861c4ee2246.png" 
              alt="Hudson Valley Trails Logo" 
              className="h-12 w-auto transition-transform duration-300 group-hover:scale-105"
            />
          </Link>

          <div className="flex items-center gap-8">
            {navLinks.map((link, index) => (
              <div key={link.path} className="flex items-center gap-8">
                <Link
                  to={link.path}
                  className={`font-sans text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                    location.pathname === link.path
                      ? isScrolled
                        ? 'text-forest'
                        : 'text-white'
                      : isScrolled
                      ? 'text-gray-700 hover:text-forest'
                      : 'text-white/90 hover:text-white'
                  }`}
                >
                  {link.name}
                </Link>
                {index < navLinks.length - 1 && (
                  <div className={`w-1 h-1 rounded-full ${isScrolled ? 'bg-forest/30' : 'bg-white/40'}`} />
                )}
              </div>
            ))}
          </div>

          <a
            href="#plan-trip"
            className="px-6 py-2.5 bg-forest text-white text-sm font-medium rounded-full hover:bg-forest-light transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Plan Your Trip
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;